import React from 'react'
import { render } from 'react-dom'
import Root from './Root';
import App from './App'

render(
    <Root>
        <App />
    </Root>
    , document.getElementById('root'))
